module.exports = __webpack_public_path__ + "img/builder-11.a7a1ff5b.webp";